module.exports = __webpack_public_path__ + "static/media/cups1.8389dab9.jpg";